import type { AbstractControl } from '@angular/forms';

import { getTextContentFromHTML } from '@core/utils-legacy';

const MEDIA_TAGS = ['<figure ', '<img ', '<video '];

export const isEmptyHtml = (value: string, mediaTagsEmpty = true) => {
  if (!value || !value.length) return true;

  if (!mediaTagsEmpty && MEDIA_TAGS.some(partialTag => value.includes(partialTag))) {
    return false;
  }

  return !getTextContentFromHTML(value)
    .replace(/\s+?/g, '')
    .replace(/&nbsp;/g, '').length;
};

export function noHTMLWhitespaceValidator(
  control: AbstractControl,
): { whitespace: boolean } | null {
  const controlValue = control.value && control.value.toString();

  const isValid = !isEmptyHtml(controlValue, false);

  return isValid ? null : { whitespace: true };
}
